import React, { useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { FieldArrayRenderProps } from "@progress/kendo-react-form";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";
import { deleteBandhaiOrderItems } from "./services/bandhai.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  setBandhaiOrderItemIndex,
  setBandhaiOrderSave,
  setBandhaiPreviousOrder,
} from "./bandhaiSlice";
import { FaEdit, FaEye } from "react-icons/fa";
import { setOrderImageViewPayload } from "../order/orderSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { ImCross } from "react-icons/im";
import moment from "moment";
import Slider from "react-slick";
import { PROCESS_ID } from "../../_contstants/common";
import { findProductImageByProcess } from "../item/services/item.services";
import { findbyOrderNo } from "../order/services/order.services";
import { formatWeight } from "../../_helper/helper";

const BandhaiOrderListArray = (
  fieldArrayRenderProps: FieldArrayRenderProps,
) => {
  const dispatch = useAppDispatch();

  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const BandhaiOrderItemIndex = useAppSelector(
    (state) => state.bandhai.BandhaiOrderItemIndex,
  );
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const PurityList = useAppSelector((state) => state.purity.PurityList);
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory.ItemCategoryList,
  );

  const handleDeleteAction = React.useCallback(
    async (index: any) => {
      if (fieldArrayRenderProps?.value[index]?.id) {
        const response = await dispatch(
          deleteBandhaiOrderItems(fieldArrayRenderProps?.value[index].id),
        );
        if (response.meta.requestStatus === "fulfilled") {
          fieldArrayRenderProps.onRemove({ index: index });
          dispatch(closeDialog());
          dispatch(setBandhaiOrderItemIndex(-1));
        }
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closeDialog());
        dispatch(setBandhaiOrderItemIndex(-1));
      }
    },
    [fieldArrayRenderProps],
  );

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog("bandhai-Order-Item-Delete-Dialog"));
    dispatch(setBandhaiOrderItemIndex(index));
  };

  const handleOpenEditOrderDialog = (index: any) => {
    dispatch(openDialog("show-bandhai-items-details-dialog"));
    dispatch(setBandhaiOrderItemIndex(index));
    dispatch(setBandhaiOrderSave(true));
    const BandhaiItemDetails =
      fieldArrayRenderProps.formRenderProps.valueGetter(
        `bandhai_order.${index}`,
      );
    dispatch(
      setBandhaiPreviousOrder(
        JSON.parse(
          JSON.stringify({
            ...BandhaiItemDetails,
            approval_items: BandhaiItemDetails?.approval_items?.length
              ? BandhaiItemDetails?.approval_items?.map((approvalItem: any) => {
                  return {
                    ...approvalItem,
                    IssueDate: approvalItem.IssueDate
                      ? moment(approvalItem.IssueDate).toDate()
                      : null,
                  };
                })
              : [],
          }),
        ),
      ),
    );
  };
  const handleOrderView = async (itemID: any, order_no: any) => {
    const payload = {
      process_id: PROCESS_ID.bandhai,
      item_id: itemID,
    };
    if (itemID && order_no) {
      await dispatch(findProductImageByProcess(payload));
      await dispatch(
        findbyOrderNo({ order_no, process_id: PROCESS_ID.bandhai }),
      );
      dispatch(openDialog("viewBandhaiOrderDialog"));
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <ViewOrderDetails />
      {dialogName === "bandhai-Order-Item-Delete-Dialog" && (
        <>
          <AppDialog>
            <>
              <Typography.h5>{"Delete  Bandhai Order Item"}</Typography.h5>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.p>
                    Are you sure you want to delete this?
                  </Typography.p>
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <DialogCloseButton themeColor="error" />
                  <Button
                    fillMode={"solid"}
                    themeColor={"error"}
                    onClick={() => handleDeleteAction(BandhaiOrderItemIndex)}
                    type="button"
                  >
                    Delete
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </>
          </AppDialog>
        </>
      )}
      <div
        className="table-responsive"
        style={{
          maxHeight: "50vh",
          scrollbarWidth: "thin",
        }}
      >
        <table
          className="table table-striped table-bordered table-hover field-array-table"
          style={{ minWidth: 1200 }}
        >
          <thead>
            <tr>
              <th style={{ width: "10%" }}>Order No</th>
              <th style={{ width: "15%" }}>Product Category</th>
              <th style={{ width: "15%" }}>Product Name</th>
              <th style={{ width: "15%" }}>Purity</th>
              <th style={{ width: "15%" }}>Estimated Weight(gm)</th>
              <th style={{ width: "20%" }}>Remark</th>
              <th style={{ width: "10%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fieldArrayRenderProps.value &&
              fieldArrayRenderProps.value.length > 0 &&
              fieldArrayRenderProps.value?.map(
                (bandhai_order: any, index: number) => (
                  <tr>
                    <td>{bandhai_order?.order_no}</td>
                    <td>
                      {ItemCategoryList &&
                        ItemCategoryList?.length > 0 &&
                        ItemCategoryList?.find(
                          (cat: any) =>
                            cat.ID === bandhai_order?.item_category_id,
                        )?.category_name}
                    </td>
                    <td>
                      {ItemList &&
                        ItemList?.length > 0 &&
                        ItemList?.find(
                          (cat: any) => cat.id === bandhai_order?.item_id,
                        )?.item_name}
                    </td>
                    <td>
                      {PurityList &&
                        PurityList?.length > 0 &&
                        PurityList?.find(
                          (cat: any) => cat.ID === bandhai_order?.purity_id,
                        )?.purity}
                    </td>
                    <td>{formatWeight(bandhai_order?.weight)}</td>
                    <td>{bandhai_order?.remarks}</td>
                    <td
                    // style={{
                    //   position: "sticky",
                    //   right: 15,
                    //   zIndex: 5,
                    // }}
                    >
                      <div style={{ display: "flex" }}>
                        <IconButton
                          type="button"
                          fillMode="flat"
                          size="small"
                          title="Edit"
                          themeColor="success"
                          onClick={() => handleOpenEditOrderDialog(index)}
                        >
                          <FaEdit
                            className="absolute-position"
                            style={{ fontSize: "24px" }}
                          />
                        </IconButton>
                        <IconButton
                          type="button"
                          fillMode="flat"
                          size="small"
                          title="Delete"
                          themeColor="error"
                          onClick={() => handleOpenDeleteDialog(index)}
                        >
                          <MdDelete
                            className="absolute-position"
                            style={{ fontSize: "24px" }}
                          />
                        </IconButton>
                        <IconButton
                          type="button"
                          fillMode="flat"
                          size="small"
                          title="View"
                          themeColor="info"
                          onClick={() =>
                            handleOrderView(
                              bandhai_order.item_id,
                              bandhai_order.order_no,
                            )
                          }
                        >
                          <FaEye
                            className="absolute-position"
                            style={{ fontSize: "24px" }}
                          />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                ),
              )}
          </tbody>
        </table>
      </div>
    </GridLayout>
  );
};

export default BandhaiOrderListArray;

const ViewOrderDetails = () => {
  const orderDetail = useAppSelector((state) => state.order.OrderDetail);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const processByImageList = useAppSelector(
    (state) => state.item.ProcessByImageList,
  );
  const loading = useAppSelector((state) => state.item.loading);
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    centerMode: true,
    centerPadding: "0px",
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const handleOpenImage = (url: string) => {
    if (url && typeof url === "string") {
      window.open(url);
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {dialogName === "viewBandhaiOrderDialog" && (
        <AppDialog>
          <div
            style={{
              maxHeight: "85vh",
              overflowY: "auto",
              padding: "16px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "24px",
                paddingBottom: "16px",
                borderBottom: "1px solid #eaeaea",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: 600,
                  color: "#2d3748",
                }}
              >
                Order Details
              </h2>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#e53e3e",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onClick={() => {
                  dispatch(closeDialog());
                  dispatch(setOrderImageViewPayload(null));
                }}
              >
                <ImCross style={{ color: "white", fontSize: "14px" }} />
              </div>
            </div>

            {/* Order Information Card */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "10px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px",
                }}
              >
                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Order No
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                      fontWeight: 600,
                    }}
                  >
                    {orderDetail.order_no || "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Product Name
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                      fontWeight: 600,
                    }}
                  >
                    {orderDetail.item_name || "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Order Date
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.order_date
                      ? moment(orderDetail.order_date).format("DD-MM-YYYY")
                      : "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Delivery Date
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.delivery_date
                      ? moment(orderDetail.delivery_date).format("DD-MM-YYYY")
                      : "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Estimated Amount
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.estimate_amount || "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Purity
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.purity || "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Size
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.size || "N/A"}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "14px",
                      color: "#718096",
                      fontWeight: 500,
                    }}
                  >
                    Color
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      color: "#2d3748",
                    }}
                  >
                    {orderDetail.color || "N/A"}
                  </p>
                </div>
              </div>
            </div>

            {/* Image Gallery */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              }}
            >
              <h3
                style={{
                  margin: "0 0 16px 0",
                  fontSize: "18px",
                  color: "#2d3748",
                  fontWeight: 600,
                }}
              >
                Product Images
              </h3>

              <div
                className="slider-container product-view-images"
                style={{ width: "30vw" }}
              >
                {processByImageList && processByImageList.length > 1 ? (
                  <Slider {...settings}>
                    {processByImageList &&
                      processByImageList.length > 0 &&
                      processByImageList.map((image: any, index: number) => (
                        <div>
                          <div key={index} style={{ height: 250 }}>
                            <img
                              src={image.image_name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                              onClick={() => handleOpenImage(image.image_name)}
                            />
                          </div>
                          {/* <Typography.h5 style={{ textAlign: "center" }}>
                                {image.title}
                              </Typography.h5> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 5,
                            }}
                          >
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Title
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.title || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Process Name
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.process_name || "N/A"}
                              </p>
                            </div>
                            <div
                              style={{
                                background: "#e8e8e8",
                                padding: "5px 10px",
                                borderRadius: "4px",
                              }}
                            >
                              <p
                                style={{
                                  margin: "0 0 8px 0",
                                  fontSize: "14px",
                                  color: "#718096",
                                  fontWeight: 500,
                                }}
                              >
                                Main Image
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  color: "#2d3748",
                                  fontWeight: 600,
                                }}
                              >
                                {image.isreadyimage ? "YES" : "NO"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </Slider>
                ) : (
                  <>
                    {processByImageList &&
                      processByImageList.length > 0 &&
                      processByImageList.map((image: any, index: number) => (
                        <div
                          style={{
                            width: "40%",
                            margin: "auto",
                          }}
                          key={index}
                        >
                          <img
                            src={image.image_name}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "contain",
                            }}
                            onClick={() => handleOpenImage(image.image_name)}
                          />
                        </div>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </AppDialog>
      )}
    </>
  );
};
